import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-unsaved-changes',
    templateUrl: './unsaved-changes.component.html',
    styleUrls: ['./unsaved-changes.component.scss'],
    standalone: false
})
export class UnsavedChangesComponent {

  constructor(private dialogRef: MatDialogRef<UnsavedChangesComponent>) {}

  leave(): void {
    this.dialogRef.close(true);
  }

  stay(): void {
    this.dialogRef.close(false);
  }
}
